import axios from "axios";
import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import { Link, useParams } from 'react-router-dom';
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

const VisaDetails = () => {
    const { slug } = useParams();
    const [visaDetail, setVisaDetail] = useState(null);
    const [visaTypes, setVisaTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // ১. নির্দিষ্ট ভিসার বিস্তারিত ডেটা ফেচ করা
    useEffect(() => {
        if (!slug) return;
        setLoading(true);
        const url = process.env.REACT_APP_API_VISA_DETAIL;
        axios.get(`${apiBaseUrl}${url}/${slug}`)
            .then(response => {
                setVisaDetail(response.data.data || response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching visa detail", error);
                setLoading(false);
            });
    }, [slug, apiBaseUrl]);

    // ২. সাইডবারের জন্য ভিসার ক্যাটাগরি/টাইপ ফেচ করা
    useEffect(() => {
        const url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${url}`)
            .then(response => {
                setVisaTypes(response.data.data || response.data);
            })
            .catch(error => console.error("Error fetching visa types", error));
    }, [apiBaseUrl]);

    if (loading) {
        return (
            <main className="main">
                <div className="container py-5 text-center" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </main>
        );
    }

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | {visaDetail?.name}</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/visa/details/${visaDetail?.slug}`}/>
            </Helmet>
            <main className="main bg-light">
            {/* Breadcrumb Section */}
           {/* <BreadCumb title={visaDetail?.name || "Visa Details"} label={visaDetail?.name || "Details"} />*/}

            <div className="visa-single py-5">
                <div className="container">
                    <div className="row g-4">

                        {/* Main Content Area */}
                        <div className="col-lg-8">
                            <div className="visa-details bg-white p-4 p-md-5 rounded-4 shadow-sm border-0">

                                {/* Featured Image with Modern Rounded Corners & Shadow */}
                                {visaDetail?.image && (
                                    <div className="mb-4 overflow-hidden rounded-3 h-full shadow-sm">
                                        <img
                                            className="img-fluid w-100 object-fit-cover"
                                            src={`${backendBaseUrl}${visaDetail.image}`}
                                            alt={visaDetail?.name || "Visa Image"}
                                            style={{ transition: 'transform 0.3s ease' }}
                                        />
                                    </div>
                                )}

                                <div className="content">
                                    <h3 className="mb-3 fw-bold text-dark">{visaDetail?.name}</h3>

                                    {/* Rich Text Content with Sanitizer */}
                                    <div dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(visaDetail?.long_description || "<p>No description available.</p>")
                                        }}
                                    ></div>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar Area */}
                        <div className="col-lg-4">
                            <div className="visa-sidebar d-flex flex-column gap-4">

                                {/* Visa Type Widget */}
                                <div className="widget bg-white p-4 rounded-4 shadow-sm border-0">
                                    <h4 className="title fw-bold fs-5 mb-3 pb-2 border-bottom text-primary">Visa Categories</h4>
                                    <div className="visa-list d-flex flex-column gap-2">
                                        {Array.isArray(visaTypes) && visaTypes.map((visaType) => {
                                            const isActive = visaType.slug === slug;
                                            return (
                                                <Link
                                                    key={visaType.id || visaType.slug}
                                                    className={`list-item text-decoration-none px-2 py-1 d-flex justify-content-between align-items-center p-2.5 rounded-2 transition-all ${isActive ? 'bg-primary text-white fw-semibold' : 'text-secondary bg-light hover-bg-subtle'}`}
                                                    to={`/visa/${visaType.slug}`}
                                                    style={{ transition: 'all 0.2s ease-in-out' }}
                                                >
                                                    <span>{visaType?.name}</span>
                                                    <i className={`far fa-angle-double-right ${isActive ? 'text-white' : 'text-muted'}`}></i>
                                                </Link>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Professional Help / Contact Card Widget */}
                                <div className="card text-white rounded-4 overflow-hidden border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #0d1b2a 0%, #1b263b 100%)' }}>
                                    <div className="card-body p-4 text-center">
                                        <span className="badge bg-warning text-dark mb-2 px-3 py-1 rounded-pill fw-semibold">Need Assistance?</span>
                                        <h4 className="card-title fw-bold mb-3 fs-4 text-white">Have Questions About This Visa?</h4>
                                        <p className="card-text text-white-50 small mb-4">Our expert migration consultants are here to help you through every single step safely.</p>
                                        <Link to="/contact-us" className="btn btn-warning fw-bold text-dark px-4 py-2 rounded-pill shadow-sm">
                                            Contact Us <i className="fas fa-arrow-right ms-2"></i>
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
        </>
    );
}

export default VisaDetails;